import { PagedSearch } from '../../../shared/model/paged-search.model';
export class TaskTypeSearchDto extends PagedSearch {
  Inactive: boolean;
}
